import { useState, useEffect } from 'react';
import axios from 'utils/axios';

const EventAdminService = () => {
    const [listData, setListData] = useState([]);

    const getData = async (url, action) => {
        await axios.get(url).then((response) => {
            action(response.data);
        });
    };

    useEffect(() => {
        getData('api/event', setListData);
    }, []);

    return { listData };
};

export default EventAdminService;
